import { type PropsWithChildren } from 'react'
import { AuthProvider } from 'react-oidc-context'

import { AuthSideEffects } from './AuthSideEffects'
import { assertEnv, buildOidcConfig } from './oidcConfig'

export const SkalxProvider = ({ children }: PropsWithChildren) => {
  assertEnv()

  return (
    <AuthProvider {...buildOidcConfig()}>
      <AuthSideEffects>{children}</AuthSideEffects>
    </AuthProvider>
  )
}
